import userHttpRequestInstance from '../http_requests/user/user_http_requests';
import ILoginRequestBody from "../interfaces/login_request_body.type";

const login = (
   environment: string,
   requestBody: ILoginRequestBody,
   observer: {
      loginSuccessful: Function,
      loginFailure: Function
   }
) => {
   userHttpRequestInstance.login(environment, requestBody, {
      success:(loginMessage: any) => {
         observer.loginSuccessful(loginMessage);
      },
      failure: (error: any) => {
         observer.loginFailure(error);
      }
   });
};

export default login;
